// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/lifestyle_bonus.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baa_banner {
  background-repeat: no-repeat !important;
  background-size: cover !important;
  padding: 6rem 0 2rem;
  margin-top: 0.2rem;
}
.baa_banner:after {
  content: "";
  pointer-events: none;
  position: absolute;
  inset: 0;
  background-color: rgb(0 0 0 / 48%);
}

.baab_content {
  z-index: 1;
}
.baab_content h2 {
  font-size: 1.6rem;
  font-weight: 800 !important;
  letter-spacing: 0.19rem;
  margin-top: -2rem;
  margin-bottom: 2rem;
  font-family: "Barlow", sans-serif !important;
}
.baab_content .btn_style_one,
.lifestyle_bonus .btn_style_one {
  padding: 0.6rem 7rem;
}

.baa_cnt_area {
  background-color: #354a59;
  padding: 0.4rem 0 0.2rem;
}

.baa_cnt {
  background-color: #d3d7db;
  padding: 3rem;
}

.baa_cnt h2 {
  font-size: 2.125rem;
  font-weight: 300 !important;
  font-family: "Barlow", sans-serif !important;
}

.sep_dark {
  width: 2rem;
  height: 0.2rem;
  display: inline-block;
  background-color: #2f2e2e;
}
.sep {
  margin: 2rem 0;
}
.lifestyle_bonus {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center /
    cover no-repeat;
  padding: 28rem 4rem 4rem;
}
.section_blank {
  height: 25rem;
}

@media screen and (max-width: 767px) {
  .baa_banner {
    padding: 0rem 0 4rem;
  }
  .baab_content > img {
    max-width: 200px;
  }
  .baab_content h2 {
    font-size: 1.4rem;
    letter-spacing: 0;
    margin-top: -1rem;
  }
  .baa_cnt {
    padding: 1rem;
  }
  .baa_cnt h2 {
    font-size: 1.5rem;
  }
  .baab_content .btn_style_one,
  .lifestyle_bonus .btn_style_one {
    padding: 0.6rem 3rem;
  }
  .section_blank {
    height: 15rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/affiliate/affiliate.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;EACvC,iCAAiC;EACjC,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;AACpC;;AAEA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,4CAA4C;AAC9C;AACA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE;mBACiB;EACjB,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".baa_banner {\n  background-repeat: no-repeat !important;\n  background-size: cover !important;\n  padding: 6rem 0 2rem;\n  margin-top: 0.2rem;\n}\n.baa_banner:after {\n  content: \"\";\n  pointer-events: none;\n  position: absolute;\n  inset: 0;\n  background-color: rgb(0 0 0 / 48%);\n}\n\n.baab_content {\n  z-index: 1;\n}\n.baab_content h2 {\n  font-size: 1.6rem;\n  font-weight: 800 !important;\n  letter-spacing: 0.19rem;\n  margin-top: -2rem;\n  margin-bottom: 2rem;\n  font-family: \"Barlow\", sans-serif !important;\n}\n.baab_content .btn_style_one,\n.lifestyle_bonus .btn_style_one {\n  padding: 0.6rem 7rem;\n}\n\n.baa_cnt_area {\n  background-color: #354a59;\n  padding: 0.4rem 0 0.2rem;\n}\n\n.baa_cnt {\n  background-color: #d3d7db;\n  padding: 3rem;\n}\n\n.baa_cnt h2 {\n  font-size: 2.125rem;\n  font-weight: 300 !important;\n  font-family: \"Barlow\", sans-serif !important;\n}\n\n.sep_dark {\n  width: 2rem;\n  height: 0.2rem;\n  display: inline-block;\n  background-color: #2f2e2e;\n}\n.sep {\n  margin: 2rem 0;\n}\n.lifestyle_bonus {\n  background: url(\"../../assets/images/lifestyle_bonus.webp\") center center /\n    cover no-repeat;\n  padding: 28rem 4rem 4rem;\n}\n.section_blank {\n  height: 25rem;\n}\n\n@media screen and (max-width: 767px) {\n  .baa_banner {\n    padding: 0rem 0 4rem;\n  }\n  .baab_content > img {\n    max-width: 200px;\n  }\n  .baab_content h2 {\n    font-size: 1.4rem;\n    letter-spacing: 0;\n    margin-top: -1rem;\n  }\n  .baa_cnt {\n    padding: 1rem;\n  }\n  .baa_cnt h2 {\n    font-size: 1.5rem;\n  }\n  .baab_content .btn_style_one,\n  .lifestyle_bonus .btn_style_one {\n    padding: 0.6rem 3rem;\n  }\n  .section_blank {\n    height: 15rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
